import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {
  signInAuthUserWithEmailAndPassword,
  signInWithGooglePopup,
} from "../../utils/firebase/firebase.utils";
import FormInput from "../form-input/form-input.component";
import Button, {BUTTON_TYPE_CLASSES} from "../button1/button.component";
import GoogleIcon from "../google-icon/google-icon.component";

const defaultFormField = {
  email: "",
  password: "",
};

const SignInForm = () => {
  const [formFields, setFormFields] = useState(defaultFormField);
  const [error, setError] = useState("");
  const {email, password} = formFields;
  const navigate = useNavigate();

  const resetFormfield = () => setFormFields(defaultFormField);

  const signInWithGoogle = async () => {
    setError("");
    try {
      await signInWithGooglePopup();
      navigate("/blog");
    } catch (err) {
      setError("Google sign in failed. Please try again.");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    try {
      await signInAuthUserWithEmailAndPassword(email, password);
      resetFormfield();
      navigate("/blog");
    } catch (err) {
      if (err.code === "auth/invalid-credential") {
        setError("Invalid email or password.");
      } else {
        setError("Something went wrong. Please try again.");
      }
    }
  };

  const handleChange = (event) => {
    const {name, value} = event.target;
    setFormFields({...formFields, [name]: value});
  };

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      <FormInput
        label="Email"
        type="email"
        onChange={handleChange}
        required
        name="email"
        value={email}
        placeholder="you@example.com"
      />

      <FormInput
        label="Password"
        type="password"
        onChange={handleChange}
        required
        name="password"
        value={password}
        placeholder="Your password"
      />

      {error && <p className="auth-error">{error}</p>}

      <Button type="submit">Sign In</Button>

      <div className="auth-divider">
        <span>or</span>
      </div>

      <Button
        type="button"
        buttonType={BUTTON_TYPE_CLASSES.google}
        onClick={signInWithGoogle}
      >
        <GoogleIcon/>
        Continue with Google
      </Button>
    </form>
  );
};

export default SignInForm;
